<template>
  <div class="content" :class="{overHidden:modelStatus}">
    <div class="nav " :class=" {nav_top:scrollTop}">
      <div class="logo_box">
        <img src="../assets/logo.png" alt="" v-if="!scrollTop">
        <img src="../assets/LOGO_hei.png" v-else alt="">
      </div>
      <div class="nav_content">
        <ul>
          <li class="item " @click="goTo('Home')"><span class="navActive">HOME</span></li>
          <li class="item ours " v-if="lang=='en'">
            <span>OUR PRODUCTS</span>
            <div class="our">
              <div class="items " @click="goTo('Bodys')">{{lang=='en'?'BODY LOTION':'CREMA CORPO'}}</div>
              <div class="items" @click="goTo('Sham')">SHAMPOO</div>
              <div class="items" @click="goTo('Bath')">{{lang=='en'?'BATH & SHOWER GEL':'BAGNO DOCCIA'}}</div>
            </div>
          </li>
          <li class="item ours " v-if="lang=='it'">
            <span>NOSTRI PRODOTTI</span>
            <div class="our">
              <div class="items " @click="goTo('Bodys')">CREMA CORPO</div>
              <div class="items" @click="goTo('Sham')">SHAMPOO</div>
              <div class="items" @click="goTo('Bath')">BAGNO DOCCIA</div>
            </div>
          </li>
          <li class="item" @click="goTo('Story')" v-if="lang=='en'"><span>STORY & HISTORY</span></li>
          <li class="item" @click="goTo('Story')" v-if="lang=='it'"><span>STORIA</span></li>
          <li class="item" @click="goTo('Contact')" v-if="lang=='en'"><span>CONTACT US</span></li>
          <li class="item" @click="goTo('Contact')" v-if="lang=='it'"><span>CONTATTACI</span></li>
          <li class="item" v-if="lang=='en'"><a href = 'https://amzn.to/38JGK4R' target = '_blank'>SHOP</a></li>
          <li class="item" v-if="lang=='it'"><a href = 'https://amzn.to/38JGK4R' target = '_blank'>NEGOZIO</a></li>
        </ul>
      </div>
      <div class="phone-nav-content" v-if="modelStatus" @click="toggleModel">
        <ul v-if="!twoBoxStatus">
          <li class="item active" @click="goTo('Home')">HOME</li>
          <li class="item right-arrow" @click.stop="twoBox">{{lang=='en'?'OUR PRODCTS':'NOSTRI PRODOTTI'}}</li>
          <li class="item" @click="goTo('Story')">{{lang=='en'?'STORY & HISTORY':'STORIA'}}</li>
          <li class="item" @click="goTo('Contact')">{{lang=='en'?'CONTACT US':'CONTATTACI'}}</li>
          <li class="langp" @click="langFn">
            <span :class="{langActive:lang=='en'}">EN</span>/<span class="IT" :class="{langActive:lang!='en'}">IT</span>
          </li>
        </ul>
        <div class="titleBack " v-if="twoBoxStatus" @click.stop="goBack">
          <div class="back" style="width: 0.32rem;height: .32rem">
            <img style="width: 100%;height: 100%" src="../assets/back.png" alt="">
          </div>

          <div class="titleText" style="font-size: 1rem;color: #231815;margin-top: .5rem" v-if="lang=='en'">
            <p>OUR</p>
            <p>PRODUCTS</p>
          </div>
          <div class="titleText" style="font-size: 1rem;color: #231815;margin-top: .5rem" v-if="lang=='it'">
            <p>NOSTRI</p>
            <p>PRODOTTI</p>
          </div>
        </div>
        <ul class="two" v-if="twoBoxStatus">
          <li class="item" @click="goTo('Bodys')">{{lang=='en'?'BODY LOTION':'CREMA CORPO'}}</li>
          <li class="item" @click="goTo('Sham')">SHAMPOO</li>
          <li class="item" @click="goTo('Bath')"> {{lang=='en'?'BATH & SHOWER GEL':'BAGNO DOCCIA'}} </li>
        </ul>
      </div>
      <div class="click_box" @click="toggleModel">
        <div class="top_flag"></div>
        <div class="bottom_flag"></div>
      </div>
      <div class="lang"  :class=" {lang_top:scrollTop}" @click="langFn">
        <span :class="{langActive:lang=='en'}">EN</span>/<span class="IT" :class="{langActive:lang!='en'}">IT</span>
      </div>
    </div>
    <div class="main_content">
      <div class="banner_box">
      </div>
      <div class="story_box main_item" @click="goTo('Contact')">
        <div class="message_text">
          <div class="story_flag"></div>
          <div class="text_title" v-if="lang=='en'">
            STORY &
            HISTORY
          </div>
          <div class="text_title" v-if="lang=='it'">
            STORIA
          </div>
          <div class="text_content">
            {{lang=='en'?'Our products come from the pristine lands in Italy, where the four seasons orchestra with the nature harmoniously. Here, plants are grown organically, and in full ...':'Fonte del Borgo è nata da una storia d’amore e dalla passione per la natura. Spesso insegna ai visitatori il concetto..'}}
          </div>
          <div class="more">MORE</div>
        </div>
        <div class="story_image">
          <video  id="myVideo"
                  class="video-js"
                   controls poster="../assets/story.jpg">
            <source
              src="http://cdn.idsdayanjing.com/luDW7Q45FL2TAjd03EFlV_P85SXn"
              type="video/mp4">

          </video>
        </div>
      </div>
      <div class="raff_box " @click="goTo('Story')">
        <div class="main_item">
          <div class="raff_image"></div>
          <div class="message_text">
            <div class="raff_flag"></div>
            <div class="text_title" v-if="lang=='en'">
              <p>RAFFAELLA</p>
              <p>AND</p>
              <p> HER GARDEN</p>
            </div>
            <div class="text_title" v-if="lang=='it'">
              <p>RAFFAELLA</p>
              <p>SUO</p>
              <p>GIARDINO</p>
            </div>
            <div class="text_content" v-if="lang=='en'">
              Beginning with plant science and aesthetics,
              botanist Raffaella Nannoni has …
            </div>
            <div class="text_content" v-if="lang=='it'">
              Fonte del Borgo è nata da una storia d’amore e dalla passione per la natura di Raffaella Nannoni sulla
              base di una combinazione di 35 anni d’esperienza di insegnamento e ricerca sullo sviluppo del suo giardino
              botanico con più di 100 rare varietà di rose antiche.L’ estetica botanica fonde lo stile di vita
              all'italiana con un'esperienza di cura della spa. Raffaella Nannoni spesso insegna ai visitatori il
              concetto di estetica bocanica in un mare di fiori, creando una cultura unica nelle quattro stagioni e
              applicandola al marchio - Fonte del Borgo.
            </div>
            <div class="more">MORE</div>
          </div>
        </div>
      </div>
      <div class="iphone_raff main_item" @click="goTo('Story')">
        <div class="message_text">
          <div class="raff_flag"></div>
          <div class="text_title" v-if="lang=='en'">
            <p>RAFFAELLA</p>
            <p>AND</p>
            <p> HER GARDEN</p>
          </div>
          <div class="text_title" v-if="lang=='it'">
            <p>RAFFAELLA</p>
            <p>SUO</p>
            <p>GIARDINO</p>
          </div>
          <div class="text_content" v-if="lang=='en'">
            Beginning with plant science and aesthetics,
            botanist Raffaella Nannoni has …
          </div>
          <div class="text_content" v-if="lang=='it'">
            Fonte del Borgo è nata da una storia d’amore e dalla passione per la natura di Raffaella Nannoni...
          </div>
          <div class="more">MORE</div>
        </div>
        <div class="raff_image"></div>
      </div>
      <div class="products_box main_item">
        <div class="tab_list">
          <div class="title_text">{{lang=='en'?'PRODUCTS':'PRODOTTI'}}</div>
          <ul class="list_item">
            <li :class="{active:btnStatus==1}" @click="queryData(1)">{{lang=='en'?'BODY LOTION':'CREMA CORPO'}}</li>
            <li :class="{active:btnStatus==2}" @click="queryData(2)">SHAMPOO</li>
            <li :class="{active:btnStatus==3}" @click="queryData(3)">{{lang=='en'?'BATH & SHOWR GEL':'BAGNO DOCCIA'}}
            </li>
          </ul>
        </div>
        <div class="body_lotion" @click="goDetail('body','MORINGA')">
          <div class="message_title">
            <p>{{productData.list[0].name}}</p>
            <p>{{productData.list[0].names}}</p>
            <p class="more">MORE</p>
          </div>
          <div class="body_img" :style="{backgroundImage:'url('+productData.list[0].imgUrl+')'}">
          </div>
        </div>
        <div class="orangeCitrus" v-if="btnStatus!=3">
          <div class="orange" @click="goDetail('body','ORANGE')">
            <div class="orange_img" :style="{backgroundImage:'url('+productData.list[1].imgUrl+')'}"></div>
            <div class="orange_title">
              <P>{{productData.list[1].name}}</P>
              <p>{{productData.list[1].names}}</p>
              <p class="more">MORE</p>
            </div>
          </div>
          <div class="citrus" v-if="btnStatus!=3" @click="goDetail('body','CITRUS')">
            <div class="citrus_img" :style="{backgroundImage:'url('+productData.list[2].imgUrl+')'}"></div>
            <div class="citrus_title">
              <P>{{productData.list[2].name}}</P>
              <p>{{productData.list[2].names}}</p>
              <p class="more">MORE</p>
            </div>
          </div>
          <div class="clear"></div>
        </div>
        <div class="tan" @click="goDetail('body','TONKA')">
          <div class="message_title">
            <div class="title_box">
              <p>{{btnStatus==3?productData.list[1].name:productData.list[3].name}}</p>
              <p>{{btnStatus==3?productData.list[1].names:productData.list[3].names}}</p>
              <p class="more" style="float: right;">MORE</p>
            </div>
          </div>
          <div class="tan_img" v-if="btnStatus!=3"></div>
          <div class="tan_img" v-if="btnStatus==3"
               :style="{backgroundImage:'url('+productData.list[1].imgUrl+')'}"></div>
          <div class="clear"></div>
        </div>
      </div>
      <div class="phone_products_box">
        <div class="product-tab">
          <div class="product_title">
            PRODUCTS
          </div>
          <ul class="tab_box">
            <li class="tab-item" :class="{listACtive:curIndex==index}" @click="toggleList(index)"
                v-for="(item ,index) in productsList">{{item.name}}
            </li>
            <!--<li class="tab-item">SHAMPOO</li>-->
            <!--<li class="tab-item">BATH & SHOWER GEL</li>-->
          </ul>
        </div>
        <div class="product-item">
          <div class="item" v-for="item in productsList[curIndex].list " @click="goDetailWap(item.data,item.type)">
            <div class="product-flag"></div>
            <div class="item-message">
              <div class="item-name">
                <p>{{item.name}}</p>
                <p>{{item.names}}</p>
              </div>
              <div class="item-more">
                MORE
              </div>
            </div>
            <div class="item-img">
              <img :src="item.imgUrl" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <myFooter></myFooter>
  </div>
</template>
<style scoped lang="scss">
  .content {
    width: 100%;
    position: relative;

    .clear {
      clear: both;
    }

    .nav {
      width: 100%;
      height: 80px;
      display: flex;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      margin: 0 auto;
      justify-content: space-around;
      align-items: center;
      box-sizing: border-box;
      margin: 0 auto;
      background-color: #000000;
      z-index: 1;
      font-family: CantoriaMT;

      .logo_box {
        height: 53px;
        width: 60px;
      }

      .nav_content {
        height: 100%;
        box-sizing: border-box;

        .item {
          display: inline-block;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #666666;
          margin-right: 78px;
          line-height: 80px;
          position: relative;
          a{
            text-decoration: none;
            color: #666;
          }

          .our {
            position: absolute;
            top: 80px;
            left: -80px;
            width: 260px;
            height: 191px;
            background-color: #ffffff;
            box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06);
            color: #999999;
            box-sizing: border-box;
            font-size: 14px;
            padding: 40px 43px 0;
            display: none;

            div {
              display: block;
              /*margin-bottom: 30px;*/
              height: 50px;
              line-height: 0px;
            }
          }

        }

        .navActive {
          color: #ffffff;
          border-bottom: 1px solid #FFFFFF;
        }

        .ours:hover .our {
          display: block;
        }
      }

      .hidden {
        visibility: hidden;
      }

      .phone-nav-content {
        display: none;
      }

      .click_box {
        display: none;
        height: 30px;
        width: 30px;

        div {
          border-bottom: 1px solid #FFF;
          width: 30px;
          margin-top: 10px;
        }
      }

      .lang {
        color: #666666;

        .langActive {
          color: #ffffff;
        }
      }

      .lang_top {
        color: #999999;

        .langActive {
          color: #000;
        }
      }
    }

    .nav_top {
      height: 80px;
      background-color: #ffffff;
      line-height: 80px;

      .nav_content {
        line-height: 80px;

        .item {
          line-height: 80px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #999999;

          .our {
            top: 70px;
          }
        }

        .navActive {
          border-bottom: 1px solid #231815;
          color: #231815;
        }

      }


    }

    .banner_box {
      position: relative;
      width: 100vw;
      height: 100vh;
      background: url("../assets/banner.jpg") no-repeat center;
      background-size: cover;
      overflow: hidden;
    }

    .main_content {
      font-family: Konnect-Regular;

      .main_item {
        width: 1200px;
        margin: 0 auto;
        background-size: cover;
        /*display: none;*/

      }

      .story_box {
        margin-top: 160px;
        height: 561px;

        .message_text {
          float: left;
          width: 410px;
          height: 100%;
          position: relative;

          .story_flag {
            width: 18px;
            height: 3px;
            background-color: #231815;
          }

          .text_title {
            margin-top: 283px;
            width: 240px;
            height: 101px;
            font-size: 50px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 50px;
            letter-spacing: 0px;
            color: #231815;
            font-family: CantoriaMT;
          }

          .text_content {
            width: 308px;
            height: 95px;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 24px;
            letter-spacing: 0px;
            color: #9b9b9b;
            font-family: Konnect-Regular;
          }

          .more {
            width: 70px;
            height: 21px;
            /*background-color: #231815;*/
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 1px;
            color: #231815;
            text-align: center;
            line-height: 21px;
            position: absolute;
            left: 0;
            bottom: 0;
            font-family: Konnect-Regular;
          }
        }

        .story_image {
          float: left;
          width: 790px;
          height: 100%;
          /*background: url('../assets/story.jpg') no-repeat center;*/
          background-size: cover;
          video{
            width: 790px;
            height: 100%;
            border: none;
            outline: none;
          }

        }
      }

      .story_box:hover {
        cursor: pointer;

        .message_text {
          .more {
            background-color: black;
            color: #ffff;
            font-family: Konnect-Bold;
          }
        }
      }

      .raff_box {
        padding: 100px 0;
        height: 790px;
        margin-top: 160px;
        background-color: #000000;

        .message_text {
          float: left;
          height: 790px;
          position: relative;
          text-align: right;
          padding-left: 226px;

          .story_flag {
            width: 18px;
            height: 3px;
            background-color: #231815;
          }

          .text_title {
            margin-top: 302px;
            width: 354px;
            height: 150px;
            font-size: 50px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 50px;
            letter-spacing: 0px;
            color: #D8D8D8;
            font-family: CantoriaMT;
          }

          .text_content {
            width: 354px;
            height: 94px;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 24px;
            letter-spacing: 0px;
            color: #D8D8D8;
          }

          .more {
            width: 70px;
            height: 21px;
            /*background-color: #231815;*/
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 1px;
            color: #D8D8D8;
            text-align: center;
            line-height: 21px;
            position: absolute;
            right: 0;
            bottom: 0;
            font-family: Konnect-Bold;
          }
        }

        .raff_image {
          float: left;
          width: 620px;
          height: 790px;
          background: url('../assets/Hgarden.jpg') no-repeat center;
          background-size: cover;
        }
      }

      .raff_box:hover {
        cursor: pointer;

        .message_text {
          .more {
            background-color: #fff;
            color: black;
            font-family: Konnect-Bold;
          }
        }
      }

      .iphone_raff {
        display: none;
      }

      .products_box {
        margin-top: 140px;

        .tab_list {
          height: 50px;
          display: flex;
          justify-content: space-between;
          font-family: CantoriaMT;

          .title_text {
            width: 295px;
            height: 50px;
            font-size: 50px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 50px;
            letter-spacing: 0px;
            color: #231815;
            font-family: CantoriaMT;
          }

          .list_item {
            width: 495px;
            height: 20px;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #999999;
            display: flex;
            justify-content: space-between;

            li {
              display: inline-block;
              line-height: 20px;
            }

            .active {
              background-color: #231815;
              padding: 0 10px;
              line-height: 20px;
              color: #fff;
            }

          }

          .list_item:hover {
            cursor: pointer;
          }
        }

        .body_lotion {
          height: 560px;
          margin-top: 130px;

          .message_title {
            width: 410px;
            float: left;
            padding-top: 357px;
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #231815;
            font-family: Konnect-Bold;

            .more {
              font-size: 14px;
              margin-top: 134px;
              width: 70px;
              text-align: left;
              font-family: Konnect-Regular;
            }
          }

          .body_img {
            float: left;
            width: 790px;
            height: 100%;
            background: url('../assets/producnt-1.png') no-repeat center;
            background-size: cover;
          }
        }

        .body_lotion:hover {
          cursor: pointer;

          .message_title {
            .more {
              background-color: #231815;
              color: #fff;
              width: 70px;
              text-align: center;
              font-family: Konnect-Bold;
            }
          }
        }

        .orangeCitrus {
          margin-top: 160px;
          font-size: 20px;
          position: relative;
          height: 760px;

          .orange {
            width: 790px;
            height: 380px;
            float: left;

            .orange_img {
              float: left;
              width: 380px;
              height: 380px;
              background: url('../assets/product-2.png') no-repeat center;
              background-size: cover;
            }

            .orange_title {
              float: left;
              width: 277px;
              padding-left: 133px;
              font-family: Konnect-Bold;

              .more {
                font-size: 14px;
                margin-top: 134px;
                font-family: Konnect-Regular;
              }
            }
          }

          .orange:hover {
            cursor: pointer;

            .orange_title {
              .more {
                background-color: #231815;
                color: #fff;
                width: 70px;
                text-align: center;
                padding: 3px 0;
                font-family: Konnect-Bold;
              }
            }
          }

          .citrus {
            width: 790px;
            height: 380px;
            float: right;
            position: absolute;
            top: 280px;
            right: 0;

            .citrus_img {
              float: right;
              width: 380px;
              height: 380px;
              background: url('../assets/product-3.png') no-repeat center;
              background-size: cover;
            }

            .citrus_title {
              float: left;
              width: 277px;
              position: absolute;
              bottom: 0;
              padding-left: 100px;
              font-family: Konnect-Bold;

              .more {
                font-size: 14px;
                margin-top: 134px;
                font-family: Konnect-Regular;
              }
            }
          }

          .citrus:hover {
            cursor: pointer;

            .citrus_title {
              .more {
                background-color: #231815;
                color: #fff;
                width: 70px;
                text-align: center;
                padding: 3px 0;
                font-family: Konnect-Bold;
              }
            }
          }
        }

        .tan {
          height: 560px;
          margin-top: 140px;

          .message_title {
            position: relative;
            width: 410px;
            height: 100%;
            float: right;
            text-align: right;
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #231815;
            font-family: Konnect-Bold;

            .title_box {
              position: absolute;
              right: 0;
              bottom: 0;

              .more {
                font-size: 14px;
                margin-top: 140px;
                font-family: Konnect-Regular;
              }
            }

          }

          .tan_img {
            float: left;
            width: 790px;
            height: 100%;
            background: url('../assets/product-4.png') no-repeat center;
            background-size: cover;
          }
        }

        .tan:hover {
          cursor: pointer;

          .message_title {
            .more {
              background-color: #231815;
              color: #fff;
              width: 70px;
              text-align: center;
              font-family: Konnect-Bold;
            }
          }
        }
      }

      .phone_products_box {
        display: none;
      }

    }

  }

  @media screen and (max-width: 900) {
    .content {
      width: 100%;
      position: absolute;

      .nav {
        width: 100%;
        height: 0.88rem;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        padding: 0 .3rem;
        align-items: center;
        box-sizing: border-box;
        font-family: CantoriaMT;

        .logo_box {
          height: 0.53rem;
          width: 0.6rem;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .nav_content {
          display: none;

          .item {
            display: inline-block;
            font-size: 0.14rem;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #666666;
            margin-right: 78px;
          }
        }

        .phone-nav-content {
          display: block;
          background-color: #fff;
          position: fixed;
          left: 0;
          right: 0;
          top: 0.88rem;
          bottom: 0;
          padding: 0.78rem 0.4rem;

          ul {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            animation: mymove 1s;
            position: absolute;
            top: 0.78rem;
            padding-left: 0.4rem;
            @keyframes mymove {
              from {
                left: 0;
              }
              to {
                left: .4rem;
              }
            }

            @-webkit-keyframes mymove /*Safari and Chrome*/
            {
              from {
                left: 0;
              }
              to {
                left: .4rem;
              }
            }

            .item {
              height: .36rem;
              font-size: .40rem;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: 0px;
              color: #999999;
              margin-top: 1.20rem;
              line-height: 0.36rem;
            }

            .right-arrow {
              background: url("../assets/right-arrow.png") no-repeat center right;
              background-size: .32rem .32rem;
              width: 4.5rem;
            }

            .back {

            }

            .active {
              border-bottom: 0.01rem solid #999999;
            }
          }

          ul.two {
            top: 4.75rem;
            padding-left: 0;

            .item {
              font-size: .32rem;
              margin-top: 0.6rem;

            }
          }
        }

        .langp {
          font-size: .3rem;
          color: #999999;
          margin-top: .4rem;

          .langActive {
            color: black;
            font-weight: bold;
          }
        }

        .click_box {
          height: 0.32rem;
          width: 0.32rem;
          display: block;

          div {
            border-bottom: 0.02rem solid #FFF;
            width: 0.32rem;
            margin-top: 0.1rem;
          }
        }
        .lang{
          display: none;
        }
      }

      .nav.nav_top {
        background-image: none;
        background-color: #fff;

        .click_box {
          div {
            border-bottom: 0.02rem solid black;
          }
        }
      }
      .langp {
        font-size: .3rem;
        color: #999999;
        margin-top: .4rem;

        .langActive {
          color: black;
          font-weight: bold;
        }
      }

      .banner_box {
        position: relative;
        width: 100%;
        height: 9.8rem;
        background: url("../assets/banner-home-wap.png") no-repeat center;
        background-size: cover;
        overflow: hidden;
        box-sizing: border-box;
      }

      .main_content {
        .main_item {
          width: 6.9rem;
          margin: 0 auto;
          display: block;
          padding: 0 0.3rem;
        }

        .story_box {
          margin-top: 1.2rem;
          height: auto;

          .message_text {
            float: none;
            width: 6.9rem;
            height: 5.64rem;
            position: relative;
            padding-bottom: .78rem;
            line-height: .36rem;
            font-family: Konnect-Regular;
            font-size: .24rem;

            .story_flag {
              width: 0.2rem;
              height: 0.02rem;
              background-color: #231815;
            }

            .text_title {
              margin-top: 2.8rem;
              width: 2.4rem;
              height: 1rem;
              font-size: .5rem;
              font-weight: normal;
              font-stretch: normal;
              line-height: 0.5rem;
              letter-spacing: 0px;
              color: #231815;
              font-family: CantoriaMT;
            }

            .text_content {
              margin-top: .1rem;
              width: 5rem;
              height: .95rem;
              font-size: .24rem;
              font-weight: normal;
              font-stretch: normal;
              line-height: .36rem;
              letter-spacing: 0px;
              color: #9b9b9b;
            }

            .more {
              width: 0.70rem;
              height: 0.21rem;
              background-color: #231815;
              font-size: 0.14rem;
              font-weight: normal;
              font-stretch: normal;
              color: #ffffff;
              text-align: center;
              line-height: 0.21rem;
              position: absolute;
              left: 0;
              bottom: 0;
              font-family: Konnect-Regular;
            }
          }

          .story_image {
            float: none;
            width: 6.9rem;
            height: 4.8rem;
            /*background: url('../assets/story.jpg') no-repeat center;*/
            background-size: cover;
            margin-top: 0.6rem;
            video{
              width: 6.9rem;
              height: 4.8rem;
            }
          }
        }

        .raff_box {
          display: none;
          padding: 1rem 0;

          .message_text {
            float: none;
            position: relative;
            text-align: right;

            .story_flag {
              width: 0.2rem;
              height: 0.01px;
              background-color: #231815;
            }

            .text_title {
              margin-top: 0.3rem;
              width: 0.354rem;
              height: 150px;
              font-size: 50px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 50px;
              letter-spacing: 0px;
              color: #231815;
              font-family: CantoriaMT;


            }

            .text_content {
              width: 354px;
              height: 94px;

              font-size: 14px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 24px;
              letter-spacing: 0px;
              color: #9b9b9b;
            }

            .more {
              width: 70px;
              height: 21px;
              background-color: #231815;
              font-size: 14px;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: 1px;
              color: #ffffff;
              text-align: center;
              line-height: 21px;
              position: absolute;
              right: 0;
              bottom: 0;
              font-family: Konnect-Regular;
            }
          }

          .raff_image {
            float: none;
            width: 620px;
            height: 790px;
            background: url('../assets/story.jpg') no-repeat center;
            background-size: cover;
          }
        }

        .iphone_raff {
          display: block;
          background-color: #000000;
          padding-bottom: 0.6rem;

          .message_text {
            width: 100%;
            margin-top: 1.2rem;
            padding-top: 1.2rem;

            .raff_flag {
              width: 0.2rem;
              height: 0.02rem;
              background-color: #fff;
            }

            .text_title {
              margin-top: 2.8rem;
              width: 4.54rem;
              height: 1.5rem;
              font-size: 0.5rem;
              font-weight: normal;
              font-stretch: normal;
              line-height: 0.50rem;
              letter-spacing: 0px;
              color: #D8D8D8;
              font-family: CantoriaMT;
            }

            .text_content {
              width: 3.45rem;
              height: 0.94rem;
              line-height: .36rem;
              font-size: 0.24rem;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: 0px;
              color: #D8D8D8;
              margin-top: .2rem;
              font-family: Konnect-Regular;
            }

            .more {
              width: 0.7rem;
              height: .2rem;
              background-color: #fff;
              line-height: .2rem;
              font-family: Konnect-Regular;
              text-align: center;
              font-size: .14rem;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: 0px;
              color: black;
              margin-top: .6rem;
            }

          }

          .raff_image {
            float: none;
            width: 6.9rem;
            height: 6.9rem;
            background: url('../assets/Hgarden.jpg') no-repeat center;
            background-size: cover;
            margin-top: .6rem;
          }
        }

        .products_box {
          display: none;
        }

        .phone_products_box {
          display: block;
          /*width: 7.50rem;*/
          /*height: 4.50rem;*/
          /*box-sizing: border-box;*/
          /*padding: 1.20rem .6rem .3rem;*/
          .product-tab {
            width: 7.50rem;
            height: 4.50rem;
            box-sizing: border-box;
            padding: 1.20rem .6rem .3rem;

            .product_title {
              float: left;
              width: 2.95rem;

              font-size: .50rem;
              font-weight: normal;
              font-stretch: normal;
              line-height: .50rem;
              letter-spacing: 0px;
              color: #231815;
              font-family: CantoriaMT;
            }

            .tab_box {
              float: right;
              font-size: .24rem;
              text-align: right;
              padding-top: .9rem;
              color: #999999;
              font-family: CantoriaMT;

              .listACtive {
                background-color: #231815;
                padding-left: .27rem;
                padding-top: .06rem;
                padding-bottom: .06rem;
                padding-right: .04rem;
                color: #fff;

              }

              .tab-item {
                margin-bottom: .4rem;
              }
            }

          }

          .product-item {
            width: 7.2rem;
            /*height: 8.90rem;*/
            background-color: #f2f2f2;
            /*padding-top: .6rem;*/
            padding-left: .3rem;
            overflow-x: scroll;
            overflow-y: hidden;
            -webkit-overflow-scrolling: touch;
            display: flex;

            .item {
              width: 6.2rem;
              /*height: 7.7rem;*/
              box-sizing: border-box;
              font-size: .34rem;
              color: #231815;
              margin-right: .3rem;
              padding-bottom: .3rem;
              box-sizing: border-box;

              .product-flag {
                width: 0.18rem;
                border-bottom: .02rem solid #231815;
                margin-top: .6rem;
              }

              .item-message {
                margin-top: 1.42rem;
                font-family: Konnect-Bold;
              }

              .item-more {
                margin-top: .3rem;
                color: #231815;
                font-size: .22rem;
                background: url('../assets/arrow.png') 15% center no-repeat;
                font-family: Konnect-Regular;
                background-size: .12rem .05rem;
              }

              .item-img {
                width: 6.20rem;
                height: 4.30rem;
                margin-top: .6rem;

                img {
                  width: 6.20rem;
                  height: 4.30rem;
                }
              }
            }
          }

          /*.pr*/
        }
      }

    }
    .overHidden {
      overflow: hidden;
      height: 100vh;
    }

  }

</style>
<script>
  export default {
    name: 'Home',
    data() {
      return {
        scrollTop: 0,
        windowWidth: null,
        modelStatus: false,
        pcModelStatus: false,
        curIndex: 0,
        productsList: [
          {
            name: "BODY LOTION",
            list: [
              {
                name: "MORINGA",
                names: 'BODY LOTION',
                imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190324_2975a8c6g8b17fai526ae9bffgl43_620x430.png',
                type: 'MORINGA',
                data: 'body'
              },
              {
                name: "ORANGE AND CINNAMON",
                names: 'BODY LOTION',
                imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190324_43l7agdebd6e6al1bb2dh66af089a_620x430.png',
                type: 'ORANGE',
                data: 'body'
              },
              {
                name: "CITRUS",
                names: 'BODY LOTION',
                imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190324_86e92lb8k574k1f6599a11c5j4a78_620x430.png',
                type: 'CITRUS',
                data: 'body'
              },
              {
                name: "TONKA BEANS",
                names: 'BODY LOTION',
                imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190410_04abiib6aefchk342lfagh165217c_1580x1120.jpg',
                type: 'TONKA',
                data: 'body'
              },
            ]
          },
          {
            name: "SHAMPOO",
            list: [
              {
                name: "ROSEMARY",
                names: 'SHAMPOO',
                imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190324_551ddfak0a8bbali53jd13d0il3jj_620x430.png',
                type: "ROSEMARY",
                data: 'sham'
              },
              {
                name: "NETTLE",
                names: 'SHAMPOO',
                imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190324_0128gkj06jj1032d49c84j3c855gd_620x430.png',
                type: "NETTLE",
                data: 'sham'

              },
              {
                name: "PEACH",
                names: 'SHAMPOO',
                imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190324_3aiiad3a5gda825ebahd17flg0c02_620x430.png',
                type: "PEACH",
                data: 'sham'
              },
              {
                name: "SAGE AND ARTICHOKE",
                names: 'SHAMPOO',
                imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190324_3aca6903gidf8aiia1fc78360kj16_620x430.png',
                type: "SAGE",
                data: 'sham'
              },
            ]
          },
          {
            name: "BATH & SHOWER GEL",
            list: [
              {
                name: "ROSE AND JASMINE ",
                names: 'BATH & SHOWER GEL',
                imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190324_362bh07fg5g59fi31k4gdj43c2fkl_620x430.png',
                type: "ROSE",
                data: 'bath'
              },
              {
                name: "IRIS AND POMEFRANTE",
                names: 'BATH & SHOWER GEL',
                imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190324_6434c21h284940cec2h3dld1283j8_620x430.png',
                type: "IRIS",
                data: 'bath'
              },
            ]
          },
        ],
        productsList1: [
          {
            name: "BODY LOTION",
            list: [
              {
                name: "MORINGA",
                names: 'BODY LOTION',
                imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190324_2975a8c6g8b17fai526ae9bffgl43_620x430.png',
                type: 'MORINGA',
                data: 'body'
              },
              {
                name: "ORANGE AND CINNAMON",
                names: 'BODY LOTION',
                imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190324_43l7agdebd6e6al1bb2dh66af089a_620x430.png',
                type: 'ORANGE',
                data: 'body'
              },
              {
                name: "CITRUS",
                names: 'BODY LOTION',
                imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190324_86e92lb8k574k1f6599a11c5j4a78_620x430.png',
                type: 'CITRUS',
                data: 'body'
              },
              {
                name: "TONKA BEANS",
                names: 'BODY LOTION',
                imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190410_04abiib6aefchk342lfagh165217c_1580x1120.jpg',
                type: 'TONKA',
                data: 'body'
              },
            ]
          },
          {
            name: "SHAMPOO",
            list: [
              {
                name: "ROSEMARY",
                names: 'SHAMPOO',
                imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190324_551ddfak0a8bbali53jd13d0il3jj_620x430.png',
                type: "ROSEMARY",
                data: 'sham'
              },
              {
                name: "NETTLE",
                names: 'SHAMPOO',
                imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190324_0128gkj06jj1032d49c84j3c855gd_620x430.png',
                type: "NETTLE",
                data: 'sham'

              },
              {
                name: "PEACH",
                names: 'SHAMPOO',
                imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190324_3aiiad3a5gda825ebahd17flg0c02_620x430.png',
                type: "PEACH",
                data: 'sham'
              },
              {
                name: "SAGE AND ARTICHOKE",
                names: 'SHAMPOO',
                imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190324_3aca6903gidf8aiia1fc78360kj16_620x430.png',
                type: "SAGE",
                data: 'sham'
              },
            ]
          },
          {
            name: "BATH & SHOWER GEL",
            list: [
              {
                name: "ROSE AND JASMINE ",
                names: 'BATH & SHOWER GEL',
                imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190324_362bh07fg5g59fi31k4gdj43c2fkl_620x430.png',
                type: "ROSE",
                data: 'bath'
              },
              {
                name: "IRIS AND POMEFRANTE",
                names: 'BATH & SHOWER GEL',
                imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190324_6434c21h284940cec2h3dld1283j8_620x430.png',
                type: "IRIS",
                data: 'bath'
              },
            ]
          },
        ],
        productsList2: [
          {
            name: "CREMA CORPO",
            list: [
              {
                name: "Crema corpo",
                names: 'alla moringa',
                imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190324_2975a8c6g8b17fai526ae9bffgl43_620x430.png',
                type: 'MORINGA',
                data: 'body'
              },
              {
                name: "Crema corpo",
                names: 'arancio e cannella',
                imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190324_43l7agdebd6e6al1bb2dh66af089a_620x430.png',
                type: 'ORANGE',
                data: 'body'
              },
              {
                name: "Crema corpo",
                names: 'agli agrumi',
                imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190324_86e92lb8k574k1f6599a11c5j4a78_620x430.png',
                type: 'CITRUS',
                data: 'body'
              },
              {
                name: "Crema corpo",
                names: 'alle fave di tonka',
                imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190410_04abiib6aefchk342lfagh165217c_1580x1120.jpg',
                type: 'TONKA',
                data: 'body'
              },
            ]
          },
          {
            name: "SHAMPOO",
            list: [
              {
                name: "SHAMPOO",
                names: 'al rosmarino ',
                imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190324_551ddfak0a8bbali53jd13d0il3jj_620x430.png',
                type: "ROSEMARY",
                data: 'sham'
              },
              {
                name: "SHAMPOO",
                names: 'all\'ortica',
                imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190324_0128gkj06jj1032d49c84j3c855gd_620x430.png',
                type: "NETTLE",
                data: 'sham'

              },
              {
                name: "SHAMPOO",
                names: 'alla pesca',
                imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190324_3aiiad3a5gda825ebahd17flg0c02_620x430.png',
                type: "PEACH",
                data: 'sham'
              },
              {
                name: "SHAMPOO",
                names: 'salvia e carciofo ',
                imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190324_3aca6903gidf8aiia1fc78360kj16_620x430.png',
                type: "SAGE",
                data: 'sham'
              },
            ]
          },
          {
            name: "BAGNO DOCCIA",
            list: [
              {
                name: "Bagno-doccia ",
                names: 'alla rosa e gelsomino',
                imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190324_362bh07fg5g59fi31k4gdj43c2fkl_620x430.png',
                type: "ROSE",
                data: 'bath'
              },
              {
                name: "Bagno-doccia",
                names: 'giaggiolo e melograno',
                imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190324_6434c21h284940cec2h3dld1283j8_620x430.png',
                type: "IRIS",
                data: 'bath'
              },
            ]
          },
        ],
        twoBoxStatus: false,
        btnStatus: 1,
        productData: '',
        lang: '',
        activeIndex:''
      }
    },
    computed: {},
    mounted() {
      this.lang = this.defined.lang;
      this.windowWidth = window.document.documentElement.clientWidth;
      console.log(this.defined)
      window.addEventListener('scroll', () => {
        console.log(111)
        console.log(document.getElementsByClassName('banner_box'))
        const cHeight = document.getElementsByClassName('banner_box')[0].clientHeight
        if (document.documentElement.scrollTop != 0) {
          this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        } else {
          this.scrollTop = 0;
        }


      })
      this.queryData(1);
    },
    methods: {
      goTo(data, type) {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        console.log(data)
        this.$router.push({path: `/${data}`, query: {type: type}})
      },
      langFn() {
        if (this.defined.lang == 'en') {
          this.defined.setLang('it')
          this.lang = 'it'
          this.productsList=this.productsList2
          this.productData = this.productsList[this.activeIndex];
        } else {
          this.defined.setLang('en')
          this.lang = 'en'
          this.productsList=this.productsList1
          this.productData = this.productsList[this.activeIndex];
        }
      },
      toggleModel() {
        if (this.windowWidth <= 1024 && !this.modelStatus) {
          this.modelStatus = true
          this.twoBoxStatus = false
        } else if (this.windowWidth <= 1024 && this.modelStatus) {
          this.modelStatus = false
          this.twoBoxStatus = false
        } else if (this.windowWidth > 1024 && !this.pcModelStatus) {
          this.pcModelStatus = true;
        } else if (this.windowWidth > 1024 && this.pcModelStatus) {
          this.pcModelStatus = false;
        }
      },
      toggleList(index) {
        this.curIndex = index
      },
      twoBox() {
        this.twoBoxStatus = true;
      },
      queryData(num) {
        this.btnStatus = num;
        let index = num - 1;
        this.activeIndex=index
        this.productData = this.productsList[index];
      },
      goBack() {
        this.twoBoxStatus = false;
      },
      goDetail(data, type) {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        this.$router.push({path: `/Detail`, query: {data, type}})
      },
      goDetailWap(data, type) {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        console.log(data)
        console.log(type)
        this.$router.push({path: `/Detail`, query: {data, type, wap: 'wap'}})
      }
    }

  }
</script>





// WEBPACK FOOTER //
// src/components/Home.vue